import { apply, take } from 'redux-saga/effects';

export function* root() {
    while(true) {
        const action = yield take('ga:event');
        yield apply(window, window.ga, ['send', 'event'].concat(action.payload));
    }
}



// WEBPACK FOOTER //
// ./app/sagas/ga.js